var _defs, _rect, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _polyline, _line, _polyline2, _polyline3, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _line2, _path21, _path22, _polygon2, _path23, _path24, _path25, _path26, _polygon3, _path27, _line3, _line4, _circle, _circle2, _path28, _polygon4, _text, _path29, _path30, _rect2, _rect3, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _rect4, _polygon5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialmediamarketingtab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d8c4df;}.cls-17,.cls-2{fill:#2f2143;}.cls-3{fill:#fdc435;}.cls-4{fill:#f7a9a0;}.cls-5{fill:#fff;}.cls-11,.cls-13,.cls-14,.cls-15,.cls-16,.cls-18,.cls-20,.cls-6,.cls-8,.cls-9{fill:none;stroke-miterlimit:10;}.cls-18,.cls-6{stroke:#1f3242;}.cls-6,.cls-8{stroke-width:0.63px;}.cls-7{fill:#3e4244;}.cls-8,.cls-9{stroke:#3e4244;}.cls-11,.cls-8,.cls-9{stroke-linecap:round;}.cls-9{stroke-width:0.55px;}.cls-10{fill:#9a499c;}.cls-11,.cls-15,.cls-16,.cls-20{stroke:#2f2143;}.cls-11{stroke-width:0.91px;}.cls-12{fill:#1b334f;}.cls-13{stroke:#513735;stroke-width:0.31px;}.cls-14{stroke:#491f1f;stroke-width:0.37px;}.cls-15{stroke-width:0.62px;}.cls-16{stroke-width:1.01px;}.cls-17{font-size:35px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-18{stroke-width:1.37px;}.cls-19{fill:#1f3242;}.cls-20{stroke-width:0.94px;}.cls-21{fill:#ffc537;}.cls-22{fill:#e5ac24;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social media marketing tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 765,
    height: 277
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "150.81 277 151.61 231.16 155 231.16 165.92 277 198.91 277 186.23 191.41 111.94 191.41 119.23 276.98 150.81 277"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.83,70.44,132.9,59.5a12.68,12.68,0,0,0-9.44-4.44c-6.5,0-10.07,5.47-10.34,5.9a15.72,15.72,0,0,0,1.65,19.89s3,5.5,2,10.87a19,19,0,0,1-3,5.75s-4.91,3.72-2.62,7.69h23.35a4.31,4.31,0,0,1-1.86-4.18s1.73-5.89.89-9.5a20.28,20.28,0,0,0-3.2-9.5s-7.06-11.63.57-11.54",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.09,100.2s10.73,2.63,15.44,8.89c0,0,11.62,12.47,12.9,21.33l7.37,14.06-4.33,45.13,3.13,11.73-13.56.31s-5.89-.45-5.64-8.3,1.68-50.62,1.68-50.62.13-6.19-1.81-10.42-15.18-32.11-15.18-32.11",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.46,71.86s-.58-9.71-4.1-12c0,0-6.66,9.86-16.21,10.17a23.64,23.64,0,0,1-.38,6.65l-12.1,2.52s-4-6.43-2.82-12.61c0,0,1.35-9.46,9.72-12.55a20.68,20.68,0,0,1,21.36,3.34s7.31-1.45,8,7a9.38,9.38,0,0,1-3.46,7.42",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.83,125.91l-22.5-22.47,1.4-15.5s-7,.63-8.08-7.12c0,0-.2-4.06,2.35-5.87,0,0,4.88-4.16,9.6,2.67,0,0,.55-5.75.45-7,0,0,7.56.88,16.2-10.17,0,0,4.68,2.69,4.12,15.73,0,0,2.31,4.71,1.51,8.34a10.23,10.23,0,0,1-8.71,8.53Z",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139.45,102.27l21.48,21.45-2.12-23s16.13,31.33,16.56,36.93l-1.83,52.48h-17.4Z",
    transform: "translate(0 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.56,102.28s-19.13,5-23.69,9.39S92.83,144,80,172.27c0,0-7.39,20.34,16.95,29.64a22.56,22.56,0,0,0,14.67-1.51l1.64-.84L127,201.91l22.63,1.4s8.66-1.28,6.58-13.13l-.59-36.55s-2.16-17-16.1-51.35",
    transform: "translate(0 0)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "112.63 200.31 132.66 188.67 119.54 162.74 91.85 171.32"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 112.25,
    y1: 164.26,
    x2: 122.29,
    y2: 147.81
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "139.03 106.8 135.25 122.64 144.31 133.03 142.69 141.42 153.06 154.67"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "164.96 106.8 177.03 120.97 177.03 133.03 182.53 140.02 178.64 147.81"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M155.11,74.16v.12a2.7,2.7,0,0,0,0-.48c-.25-1-1-1.59-1.67-1.4a1.07,1.07,0,0,0-.7.69V73s-.55,1.35-1.77.29c0,0,.14,1.7,1.65,1.07v-.11c0,.09,0,.17,0,.26.26,1,1,1.59,1.67,1.41A1.18,1.18,0,0,0,155,75v.08a1.82,1.82,0,0,1-.53,1.2s.24.09.59-.6a2.71,2.71,0,0,0,0-1.51",
    transform: "translate(0 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M160.77,73.72v.12a2,2,0,0,1,.06-.48c.25-1,1-1.59,1.67-1.41a1.12,1.12,0,0,1,.69.7v-.14s.55,1.36,1.77.3c0,0-.14,1.69-1.65,1.06v-.11a2.48,2.48,0,0,1,0,.27c-.25,1-1,1.59-1.67,1.4a1.17,1.17,0,0,1-.76-.88v.08a1.77,1.77,0,0,0,.54,1.19s-.25.09-.59-.59a2.77,2.77,0,0,1,0-1.51",
    transform: "translate(0 0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M158.23,74.61c0,1.11-.11,2.21-.21,3.31l-.21-.15a2.34,2.34,0,0,1,1.07-.25c1.35-.08,1.57,1.61,1.3,2.59.08-1.6-.51-2.85-2.24-2.06l-.25.1a28.28,28.28,0,0,1,.54-3.54",
    transform: "translate(0 0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M151.35,81.46a11.2,11.2,0,0,0,8.87,2.07,8.71,8.71,0,0,1-8.87-2.07",
    transform: "translate(0 0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150.4,82.68a1.69,1.69,0,0,1,1.82-1.89,2.82,2.82,0,0,0-1.82,1.89",
    transform: "translate(0 0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M149.85,69.73s3.85-2.25,6.44,0",
    transform: "translate(0 0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M159.62,69.73s2.93-2.25,4.9,0",
    transform: "translate(0 0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M135.25,77.15s5.86-5.66,7.93,3.66",
    transform: "translate(0 0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M131.52,141.91c-6.49,2.5-16.6,9.61-20.53-.54-3.6-9.73,8.28-11.9,14.34-14.8Z",
    transform: "translate(0 0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.43,126.58c9.23,22.37,23.15,16.44,14.26-6.07-9.23-22.37-23.15-16.44-14.26,6.07",
    transform: "translate(0 0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M160,140.8l-28.46,1.11-6.19-15.34,20.88-19.89c-3.55,10.61,2.7,28.44,13.77,34.12",
    transform: "translate(0 0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M125.33,126.57s-4.25,7.09,6.19,15.34",
    transform: "translate(0 0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.41,146.21s12.76,13.86,11,23.15l9.26-3.94s-9.53-9.74-11.54-22.94Z",
    transform: "translate(0 0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M177.88,103.91c6.21.71,13.11,10.63,6.72,18.71",
    transform: "translate(0 0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M180,98.77c8.18.92,17.25,14,8.84,24.62",
    transform: "translate(0 0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M181.49,92.68c10.73,1.21,22.65,18.37,11.6,32.32",
    transform: "translate(0 0)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 139.21,
    y1: 75.55,
    x2: 139.03,
    y2: 79.24
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.55,162.62l1.17-.37s2.89-7.6,3.08-7.91,2.31-3.36,4.88-3.73l4.41-1.42a5.94,5.94,0,0,1,3,.39s3.11,1,1.64,3.48l1.95,6.57s.55,4.67-4.57,4c0,0-3.42,4.21-8,3.69l-1.82,1.9Z",
    transform: "translate(0 0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M145.85,89.23s2.32,3.8,11.24,3.42",
    transform: "translate(0 0)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "122.92 171.97 119.05 162.67 119.95 162.48 125.71 169.04 122.92 171.97"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M131.68,152.79s4.43-2.63,6.1.27",
    transform: "translate(0 0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M132.2,155.33s4.43-2.64,6.1.26",
    transform: "translate(0 0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M133.07,157.86s4.43-2.63,6.1.27",
    transform: "translate(0 0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M133.64,160s4.43-2.63,6.11.27",
    transform: "translate(0 0)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "170.98 189.07 205.6 189.07 230.61 135.88 195.99 135.88 170.98 189.07"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M213.86,171.9s1.82-4,1-6.32-2.81-8.12-2.81-8.12,2-6.67,7.23-5.46c0,0,1.86.18,4.29,6.1l-1-9.65s1.14-4.08,3-.28l.87,11.72a4.24,4.24,0,0,1-2.4,3.58s-5.25,8.82-10.3,8.43",
    transform: "translate(0 0)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 214.28,
    y1: 156.4,
    x2: 217.52,
    y2: 163.38
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 215.9,
    y1: 153.9,
    x2: 220.52,
    y2: 160.89
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 38.66,
    cy: 211.05,
    r: 7.74
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 301.72,
    cy: 47.98,
    r: 12.47
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.26,245.12l-17.49,10.93a5.84,5.84,0,0,1-8-1.86l-5-8a5.84,5.84,0,0,1,1.85-8l17.49-10.93a5.85,5.85,0,0,1,8,1.85l5,8a5.84,5.84,0,0,1-1.85,8",
    transform: "translate(0 0)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "301.19 243.73 298.57 239.54 303.5 239.37 308.44 239.19 306.12 243.56 303.8 247.92 301.19 243.73"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(266.42 141.2)"
  }, "SOCIAL MEDIA ", /*#__PURE__*/React.createElement("tspan", {
    x: 29.04,
    y: 38
  }, "MARKETING"))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M578.07,224.3l-9.91,5.63a2.43,2.43,0,0,0-.38.13c-.63.29-1.26.61-1.91.88a37.15,37.15,0,0,1-7.29,2.21.38.38,0,0,1-.48-.25q-4.85-8.52-9.69-17.05a.6.6,0,0,1,0-.58,29.85,29.85,0,0,0,1.76-5.29,11.8,11.8,0,0,0,.21-4.43c-.33-1.89-.61-3.79-.86-5.69a5,5,0,0,1,0-1.69,3.17,3.17,0,0,1,5.23-1.71,9.9,9.9,0,0,1,1.39,1.71,30.41,30.41,0,0,1,2.92,6.57c.21.57.39,1.15.6,1.78l.42-.24,6.6-3.74a3.91,3.91,0,0,1,5.83,2.31,8.48,8.48,0,0,1,.19,1.34,4.2,4.2,0,0,1,2.53,1.08l.49.49.48.83a12.31,12.31,0,0,1,.22,1.89,8.4,8.4,0,0,1-.38,1.6,3.87,3.87,0,0,1,2,2.47,3.92,3.92,0,0,1-.54,3.22l.24.16a3.89,3.89,0,0,1,1.5,4.7,5.19,5.19,0,0,1-1.17,1.67",
    transform: "translate(0 0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M546.83,217.61l9.24,16.26-.33.2c-1.77,1-3.55,2-5.33,3a1.18,1.18,0,0,1-1.85-.51q-4-7-7.91-13.93a1.15,1.15,0,0,1,.49-1.81l5.37-3,.32-.19",
    transform: "translate(0 0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 499.62,
    y: 35.97,
    width: 33.01,
    height: 33.01,
    rx: 6.2,
    transform: "translate(33.47 242.7) rotate(-27.32)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 505.1,
    y: 41.46,
    width: 22.05,
    height: 22.05,
    rx: 6.2,
    transform: "translate(33.47 242.7) rotate(-27.32)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M519.67,50.64a4,4,0,1,1-5.38-1.72A4,4,0,0,1,519.67,50.64Z",
    transform: "translate(0 0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M520.52,42.88a1.73,1.73,0,1,1-2.32-.74,1.73,1.73,0,0,1,2.32.74",
    transform: "translate(0 0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M728.91,227a28.66,28.66,0,1,1-28.65-28.65A28.66,28.66,0,0,1,728.91,227Z",
    transform: "translate(0 0)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M688.23,253c-17.37-26.12,0-52,0-52",
    transform: "translate(0 0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M712.22,200.94s17.37,25.89,0,52",
    transform: "translate(0 0)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M697.7,199.08s-17.93,30.76,0,56",
    transform: "translate(0 0)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M703,199.08s17.93,30.64,0,55.85",
    transform: "translate(0 0)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M724.22,211.24c-20.7,14.87-48.58,1-48.58,1l-4,12.16s30.24,15.16,57.2,0Z",
    transform: "translate(0 0)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M675.64,241.62s24.12,11.85,49.23,0",
    transform: "translate(0 0)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M687,201.55s16.55,5.65,26.87,0",
    transform: "translate(0 0)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M678.14,216.49c.8.22,1.6.42,2.41.62q.32,3,.78,6c1.16-1.68,2.27-3.37,3.33-5.09l1.49.27c.39,1.95.82,3.91,1.31,5.86,1-1.74,1.91-3.49,2.81-5.26.82.1,1.64.19,2.47.26q-2.28,4.78-5,9.44l-1.77-.26q-.75-3-1.36-6c-1.09,1.72-2.24,3.42-3.43,5.1l-1.73-.37c-.59-3.54-1-7.06-1.33-10.58",
    transform: "translate(0 0)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M693.05,219.16l2.46.18c.56,1.92,1.16,3.84,1.82,5.74q1.24-2.78,2.36-5.6h1.51c.73,1.86,1.5,3.7,2.32,5.54q1-2.84,1.83-5.68c.82-.05,1.65-.11,2.47-.18q-1.4,5.11-3.21,10.17l-1.78.06q-1.27-2.79-2.39-5.63c-.78,1.89-1.6,3.76-2.47,5.63l-1.76-.06q-1.8-5.06-3.16-10.17",
    transform: "translate(0 0)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M708.13,219.13c.82-.07,1.64-.16,2.45-.26q1.35,2.69,2.82,5.33.74-3,1.34-5.94l1.48-.26q1.57,2.53,3.29,5c.31-2,.57-3.95.79-5.92.81-.19,1.62-.4,2.42-.62q-.47,5.28-1.37,10.59l-1.75.38c-1.17-1.69-2.29-3.39-3.37-5.12q-.63,3-1.43,6c-.58.09-1.16.18-1.74.25q-2.67-4.65-4.93-9.44",
    transform: "translate(0 0)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 670.26,
    y: 49.26,
    width: 28.23,
    height: 45.31,
    transform: "translate(430.37 711.46) rotate(-74.34)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "666.37 52.22 684.37 71.92 709.99 64.45 666.37 52.22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmediamarketingtab);
export default __webpack_public_path__ + "static/media/social media marketing tab.140b9ac020e2cd72dcc4efb2a86c456a.svg";
export { ForwardRef as ReactComponent };